(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    const assetCache = new Map();

    function escapeHtml(value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function escapeAttribute(value) {
      return escapeHtml(value);
    }

    function buildCountLabel(count) {
      return `${count} product${count === 1 ? '' : 's'}`;
    }

    function buildStateCityDescription(stateName, count) {
      const normalizedStateName = String(stateName || '').trim();
      const normalizedCount = Number(count) || 0;
      if (!normalizedStateName) return '';

      return `Hey ${normalizedStateName}! 👋🏻 We've got ${normalizedCount} pickleball leagues 🏓 running across ${normalizedStateName} right now. Find your city below 👇 and see venue info, maps, and local league details.`;
    }

    function getTodayIso(now = new Date()) {
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    function isProductCurrent(product, now = new Date()) {
      const scheduleEndDate = String(product?.schedule_end_date || '').trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(scheduleEndDate)) return true;

      return scheduleEndDate >= getTodayIso(now);
    }

    function filterCurrentProducts(products, now = new Date()) {
      return (Array.isArray(products) ? products : []).filter((product) => isProductCurrent(product, now));
    }

    function readHandleSet(grid) {
      if (!grid) return [];
      return Array.from(grid.querySelectorAll('[data-product-handle]'))
        .map((node) => node.getAttribute('data-product-handle') || '')
        .filter(Boolean);
    }

    function loadAsset(assetUrl) {
      if (!assetUrl) return Promise.resolve(null);
      if (!assetCache.has(assetUrl)) {
        assetCache.set(
          assetUrl,
          fetch(assetUrl)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`State products asset failed with ${response.status}`);
              }
              return response.json();
            })
            .catch((error) => {
              console.warn('[state-products] unable to load asset', error);
              return null;
            })
        );
      }
      return assetCache.get(assetUrl);
    }

    function buildMedia(product) {
      if (!product.image_url) {
        return `
          <a href="${escapeAttribute(product.url)}" class="card__media media-wrapper" tabindex="-1">
            <div class="card--image-animate image-animate media media--square media--hover-effect"></div>
          </a>
        `;
      }

      const width = Number(product.image_width) > 0 ? ` width="${Number(product.image_width)}"` : '';
      const height = Number(product.image_height) > 0 ? ` height="${Number(product.image_height)}"` : '';

      return `
        <a href="${escapeAttribute(product.url)}" class="card__media media-wrapper" tabindex="-1">
          <div class="card--image-animate image-animate media media--square media--hover-effect">
            <picture class="motion-reduce">
              <img
                src="${escapeAttribute(product.image_url)}"
                alt="${escapeAttribute(product.image_alt || product.title)}"
                loading="lazy"${width}${height}
              >
            </picture>
          </div>
        </a>
      `;
    }

    function buildPrice(product) {
      if (!product.formatted_price) return '';

      return `
        <div class="price">
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden">Regular price</span>
              <span class="price-item price-item--regular">${escapeHtml(product.formatted_price)}</span>
            </div>
          </div>
        </div>
      `;
    }

    function buildCard(product) {
      return `
        <li class="grid__item" data-product-handle="${escapeAttribute(product.handle)}">
          <div class="card-wrapper">
            <div class="card card--product">
              ${buildMedia(product)}
              <div class="card-information">
                <a href="${escapeAttribute(product.url)}" class="full-unstyled-link">
                  <span class="visually-hidden">${escapeHtml(product.title)}</span>
                </a>
                <div class="card-information__wrapper">
                  <a href="${escapeAttribute(product.url)}" class="card-information__text h4" tabindex="-1">${escapeHtml(product.title)}</a>
                  ${buildPrice(product)}
                </div>
              </div>
            </div>
          </div>
        </li>
      `;
    }

    function updateProductCounts(section, count) {
      const label = buildCountLabel(count);
      section.querySelectorAll('.product-count__text').forEach((node) => {
        node.textContent = label;
      });
    }

    function updateStateCityDescription(section, count) {
      const stateHandle = String(section?.dataset?.stateHandle || '').trim();
      if (!stateHandle) return;

      const citySection = document.querySelector(`.sp-state-city-pages[data-state-handle="${CSS.escape(stateHandle)}"]`);
      const descriptionNode = citySection?.querySelector('.sp-state-city-pages__description');
      const stateName = citySection?.dataset?.stateName || '';
      const normalizedCount = Number(count);
      if (!descriptionNode || !stateName || !Number.isFinite(normalizedCount)) return;

      citySection.dataset.currentLiveProductCount = String(count);
      descriptionNode.textContent = buildStateCityDescription(stateName, normalizedCount);
    }

    function shouldUseAssetProducts(assetProducts, nativeHandles, hasAssetSource = false) {
      return Boolean(hasAssetSource);
    }

    async function hydrateStateProducts(section) {
      const stateHandle = section.dataset.stateHandle;
      const assetUrl = section.dataset.stateProductsUrl;
      const assetCollection = section.querySelector('.sp-state-products__asset-collection');
      const assetGrid = assetCollection?.querySelector('.product-grid');
      const nativeGrid = section.querySelector('#product-grid');

      if (!stateHandle || !assetUrl || !assetCollection || !assetGrid) return;

      const payload = await loadAsset(assetUrl);
      const state = payload?.states?.[stateHandle];
      const allAssetProducts = Array.isArray(state?.products) ? state.products : [];
      const assetProducts = filterCurrentProducts(allAssetProducts);

      if (!allAssetProducts.length) return;

      const nativeHandles = readHandleSet(nativeGrid);
      if (!shouldUseAssetProducts(assetProducts, nativeHandles, allAssetProducts.length > 0)) {
        updateProductCounts(section, nativeHandles.length || assetProducts.length);
        return;
      }

      /* Use the state product asset as the current-league source of truth on pSEO state pages. */
      assetGrid.innerHTML = assetProducts.map((product) => buildCard(product)).join('');
      assetCollection.hidden = false;
      section.classList.add('sp-state-products--asset-mode');
      updateProductCounts(section, assetProducts.length);
      updateStateCityDescription(section, assetProducts.length);
    }

    function initStateProductSections(root = document) {
      root.querySelectorAll('.sp-state-products[data-state-handle][data-state-products-url]').forEach((section) => {
        hydrateStateProducts(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initStateProductSections());
    } else {
      initStateProductSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target) return;
      initStateProductSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["state-city-pages"]) return;
  try {
    
  (() => {
    const assetCache = new Map();

    function escapeHtml(value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function normalizePath(value) {
      const normalizedValue = String(value ?? '').trim();
      if (!normalizedValue) return '';

      try {
        const url = new URL(normalizedValue, window.location.origin);
        return url.pathname.replace(/\/+$/, '') || '/';
      } catch {
        return normalizedValue.replace(/^https?:\/\/[^/]+/i, '').replace(/\/+$/, '') || '/';
      }
    }

    async function loadAsset(assetUrl) {
      if (assetCache.has(assetUrl)) return assetCache.get(assetUrl);

      const promise = fetch(assetUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Failed to load state city pages asset: ${response.status}`);
          }
          return response.json();
        });

      assetCache.set(assetUrl, promise);
      return promise;
    }

    function buildCardMarkup(cityPage) {
      const cityUrl = escapeHtml(cityPage?.url || '#');
      const cityName = escapeHtml(cityPage?.city_name || cityPage?.city_slug || 'City');
      const imageUrl = escapeHtml(cityPage?.image_url || '');
      const imageAlt = escapeHtml(cityPage?.image_alt || `${cityName} league page`);
      const badgeText = escapeHtml(cityPage?.badge_text || '');
      const badgeMarkup = badgeText
        ? `<span class="sp-state-city-pages__badge">${badgeText}</span>`
        : '';
      const mediaMarkup = imageUrl
        ? `
          <span class="sp-state-city-pages__media">
            ${badgeMarkup}
            <img
              class="sp-state-city-pages__image"
              src="${imageUrl}"
              alt="${imageAlt}"
              loading="lazy"
              width="720"
              height="540"
            >
          </span>
        `.trim()
        : `
          <span class="sp-state-city-pages__media sp-state-city-pages__media--placeholder" aria-hidden="true">
            ${badgeMarkup}
          </span>
        `.trim();

      return `
        <a class="sp-state-city-pages__card" href="${cityUrl}">
          ${mediaMarkup}
          <span class="sp-state-city-pages__body">
            <span class="sp-state-city-pages__title">${cityName}</span>
            <span class="sp-state-city-pages__cta">Explore City Leagues -&gt;</span>
          </span>
        </a>
      `.trim();
    }

    function buildStateDescription(stateName, liveProductCount) {
      const normalizedStateName = String(stateName || '').trim();
      const normalizedCount = Number(liveProductCount) || 0;

      if (!normalizedStateName) return '';

      return `Hey ${normalizedStateName}! 👋🏻 We've got ${normalizedCount} pickleball leagues 🏓 running across ${normalizedStateName} right now. Find your city below 👇 and see venue info, maps, and local league details.`;
    }

    function readLiveProductCount(value) {
      if (value === '' || value == null) return null;

      const numeric = Number(value);
      return Number.isFinite(numeric) ? numeric : null;
    }

    function getInitialLiveProductCount(section) {
      return readLiveProductCount(section?.dataset?.initialLiveProductCount);
    }

    function getCurrentLiveProductCount(section) {
      return readLiveProductCount(section?.dataset?.currentLiveProductCount);
    }

    function resolveLiveProductCount(section, fallbackCount = 0) {
      const currentLiveProductCount = getCurrentLiveProductCount(section);
      if (currentLiveProductCount !== null) return currentLiveProductCount;

      const initialLiveProductCount = getInitialLiveProductCount(section);
      if (initialLiveProductCount !== null) return initialLiveProductCount;

      return readLiveProductCount(fallbackCount) || 0;
    }

    function ensureStructure(section, stateName, liveProductCount = resolveLiveProductCount(section)) {
      let content = section.querySelector('.sp-state-city-pages__content');
      if (!content) {
        section.innerHTML = `
          <div class="sp-state-city-pages__content">
            <div class="sp-state-city-pages__header">
              <h2 id="StateCityPages-${section.dataset.sectionId || ''}" class="sp-state-city-pages__heading"></h2>
            </div>
            <div class="sp-state-city-pages__grid"></div>
          </div>
        `.trim();
        content = section.querySelector('.sp-state-city-pages__content');
      }

      let heading = content.querySelector('.sp-state-city-pages__heading');
      let header = content.querySelector('.sp-state-city-pages__header');
      if (!header) {
        header = document.createElement('div');
        header.className = 'sp-state-city-pages__header';
        if (heading) {
          header.append(heading);
        }
        content.prepend(header);
      }

      if (!heading) {
        heading = document.createElement('h2');
        heading.id = `StateCityPages-${section.dataset.sectionId || ''}`;
        heading.className = 'sp-state-city-pages__heading';
      }

      let description = content.querySelector('.sp-state-city-pages__description');
      if (!description) {
        description = content.querySelector('p');
      }

      if (!description) {
        description = document.createElement('p');
        description.className = 'sp-state-city-pages__description';
      } else {
        description.classList.add('sp-state-city-pages__description');
      }

      if (description.parentElement !== header) {
        header.append(description);
      }

      if (heading.parentElement !== header) {
        header.append(heading);
      }

      header.insertBefore(description, heading);

      let grid = content.querySelector('.sp-state-city-pages__grid');
      if (!grid) {
        grid = document.createElement('div');
        grid.className = 'sp-state-city-pages__grid';
        content.append(grid);
      }

      heading.textContent = `Explore Our ${stateName} Pickleball Leagues by City`;
      description.textContent = buildStateDescription(stateName, liveProductCount);
      header.querySelectorAll('.sp-state-city-pages__eyebrow').forEach((node) => node.remove());

      return { grid, description };
    }

    function collectExistingCards(section) {
      const existingByUrl = new Map();

      section.querySelectorAll('.sp-state-city-pages__card[href]').forEach((card) => {
        const key = normalizePath(card.getAttribute('href'));
        if (!key || existingByUrl.has(key)) return;

        const clone = card.cloneNode(true);
        clone.querySelectorAll('.sp-state-city-pages__label').forEach((node) => node.remove());
        const cta = clone.querySelector('.sp-state-city-pages__cta');
        if (cta) cta.textContent = 'Explore City Leagues ->';
        existingByUrl.set(key, {
          hasImage: Boolean(clone.querySelector('.sp-state-city-pages__image, img')),
          hasBadge: Boolean(clone.querySelector('.sp-state-city-pages__badge')),
          html: clone.outerHTML,
        });
      });

      return existingByUrl;
    }

    function shouldUseExistingCard(existingCard, cityPage) {
      const hasExpectedImage = Boolean(String(cityPage?.image_url || '').trim());
      const hasExpectedBadge = Boolean(String(cityPage?.badge_text || '').trim());

      if (!existingCard) return false;
      if (hasExpectedImage && !existingCard.hasImage) return false;
      if (hasExpectedBadge && !existingCard.hasBadge) return false;
      if (!hasExpectedBadge && existingCard.hasBadge) return false;

      return true;
    }

    function normalizeStaticContent(section, stateName) {
      if (!stateName) return;

      ensureStructure(section, stateName, resolveLiveProductCount(section));
      section.querySelectorAll('.sp-state-city-pages__label').forEach((node) => node.remove());
      section.querySelectorAll('.sp-state-city-pages__cta').forEach((cta) => {
        cta.textContent = 'Explore City Leagues ->';
      });
    }

    function renderStateEntry(section, stateEntry) {
      const stateName = stateEntry?.title || section.dataset.stateName?.trim();
      const liveProductCount = resolveLiveProductCount(section, stateEntry?.live_product_count);
      if (!stateName) return;

      const existingByUrl = collectExistingCards(section);
      const { grid } = ensureStructure(section, stateName, liveProductCount);
      const cityPages = Array.isArray(stateEntry?.city_pages) ? stateEntry.city_pages : [];

      const cardsHtml = cityPages.map((cityPage) => {
        const cityUrl = normalizePath(cityPage?.url);
        const existingCard = existingByUrl.get(cityUrl);
        return shouldUseExistingCard(existingCard, cityPage)
          ? existingCard.html
          : buildCardMarkup(cityPage);
      }).join('');

      grid.innerHTML = cardsHtml;
      const description = section.querySelector('.sp-state-city-pages__description');
      if (description) {
        description.textContent = buildStateDescription(stateName, liveProductCount);
      }

      const hasMissingCards = cityPages.some((cityPage) => {
        const cityUrl = normalizePath(cityPage?.url);
        return !shouldUseExistingCard(existingByUrl.get(cityUrl), cityPage);
      });
      section.classList.toggle(
        'sp-state-city-pages--asset-mode',
        hasMissingCards || cityPages.length !== existingByUrl.size
      );
      normalizeStaticContent(section, stateName);
    }

    async function hydrateSection(section) {
      const stateName = section.dataset.stateName?.trim();
      const stateHandle = section.dataset.stateHandle?.trim();
      const assetUrl = section.dataset.stateCityPagesUrl?.trim();

      if (!stateHandle || !assetUrl) {
        normalizeStaticContent(section, stateName);
        return;
      }

      try {
        const asset = await loadAsset(assetUrl);
        const stateEntry = asset?.states?.[stateHandle];
        if (stateEntry?.city_pages?.length) {
          renderStateEntry(section, stateEntry);
          return;
        }
      } catch (error) {
        console.warn(error);
      }

      normalizeStaticContent(section, stateName);
    }

    const sections = document.querySelectorAll('.sp-state-city-pages[data-state-name]');

    for (const section of sections) {
      void hydrateSection(section);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
